import React from "react";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import { styled } from "@mui/material/styles";

const BlackTooltip = styled(({ className, ...props }) => (
  <Tooltip
    title="Debt Redemption License"
    classes={{ popper: className }}
    {...props}
    arrow
  />
))(({ theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "rgb(3 105 161)",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "rgb(3 105 161)",
    marginTop: "10px !important",
    fontWeight: "bold",
  },
}));

const TrustedBy = () => {
  const links = [
    {
      url: "https://www.bbb.org/us/tx/san-antonio/profile/debt-relief-education/debt-redemption-dba-affordable-debt-consolidation-0825-90006140",
      image: "/images/bbb-a-plus.webp",
      border: true,
    },
    {
      url: "https://www.bbb.org/us/tx/san-antonio/profile/debt-relief-education/debt-redemption-dba-affordable-debt-consolidation-0825-90006140",
      image: "/images/VeteranOwned.svg",
      border: true,
    },
    {
      url: "https://www.bbb.org/us/tx/san-antonio/profile/debt-relief-education/debt-redemption-dba-affordable-debt-consolidation-0825-90006140",
      image: "/images/made-for-texans.webp",
      border: false,
    },
    {
      url: "https://iapda.org/search-company?companyName=Debt+Redemption",
      image: "/images/IADPA-certified-member.webp",
      border: false,
    },
  ];

  return (
    <div className="bg-white pb-16">
      <div className="container mx-auto text-center px-4 sm:px-8">
        <h2 className="text-2xl sm:text-4xl text-black uppercase mb-12">
          Trusted By <strong>Texans</strong>
        </h2>
        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-4">
          {links.map(({ url, image, border }, index) => (
            <a
              className={`flex items-center justify-center ${
                border ? "border" : ""
              } rounded-xl`}
              href={url}
              target="_blank"
              rel="noreferrer"
              key={index}
            >
              <img
                src={image}
                className="w-full h-auto m-auto max-h-60"
                alt="Texans Logo"
              />
            </a>
          ))}
        </div>
        <h5 className="text-2xl mt-8 mb-4 uppercase">
          STATE OF TEXAS DEBT MANAGEMENT LICENSE
        </h5>
        <BlackTooltip>
          <button className="text-sky-700 text-2xl font-semibold">
            1900064636-215879
          </button>
        </BlackTooltip>
      </div>
    </div>
  );
};

export default TrustedBy;
